export default function initReadMore() {
    const $readMoreElements = document.querySelectorAll<HTMLElement>('[data-read-more]');

    $readMoreElements.forEach($element => {
        new ReadMore($element);
    });
}

/**
 * add class appear on element with data-appear-anim
 *
 * @param {HTMLElement} $el HTML Element
 * @param {HTMLElement} $target HTML Element
 */
class ReadMore {
    $el: HTMLElement;
    $target: HTMLElement | null;
    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$target = document.querySelector<HTMLElement>('[data-read-more-target='+ this.$el.dataset.readMore +']');
        this.init();
    }

    init() {
        if (this.$target) {
            this.$el.addEventListener('click', () => {
                this.$target?.classList.remove('hidden');
                this.$el.classList.add('hidden');
            })
        }
    }
}
